module.exports = __webpack_public_path__ + "static/media/frutiger-55roman.365019ed.woff";